export interface CredencialResumo {
  id: string | null
  nome: string | null
  codigoPrestador: string | null
  operadora: string | null
  tabela: string | null
  ativa: boolean
  createdAt: string
  credencialElegibilityId: string | null
  clienteId: string
  nomeCliente: string | null
}

export interface CredencialTipoToken {
  id: string
  descricao: string
}

export type TipoPermissao = 'Nenhum' | 'PontoAtendimento' | 'Unidade' | 'Usuario'

export interface OperadoraResumo {
  id: string | null
  razaoSocial: string | null
  nomeFantasia: string | null
  registroAns: string | null
}

export interface TipoArquivoAceito {
  id: number
  nome: string | null
  contentType: string | null
  extensoes: string[]
}

export interface TiposCredenciaisResumo {
  id: string | null
  nomeAmigavel: string | null
  codigoOperadora: string | null
  operadoras: OperadoraResumo | null
  limitOfProceduresPerRequest: number | null
  hasCpf: boolean
  hasCnpj: boolean
  hasTipoLogin: boolean
  hasUnidadeLogin: boolean
  tipoArquivos: TipoArquivoAceito[]
}

export interface ProfissionalResumo {
  id: string | null
  nome: string | null
  cpfCnpj: string | null
  registroConselho: string | null
  ufConselho: string | null
}

export interface EspecialidadeSelect {
  label: string | null
  value: number
}

export interface Credencial {
  id: string | null
  clienteId: string
  tiposCredenciaisId: string
  tiposCredenciais: TiposCredenciaisResumo | null
  nome: string | null
  codigoPrestador: string | null
  observacoes: string | null
  login: string | null
  senha: string | null
  cpf: string | null
  cnpj: string | null
  tipoLogin: string | null
  unidadeLogin: string | null
  tabela: string | null
  hasBiometrics: boolean
  hasExecution: boolean
  visivel: boolean
  ativa: boolean
  acceptJustification: boolean
  solicitaTokenPreAutorizacao: boolean
  requerTokenAutorizacao: boolean
  obrigarAnexoNaAutorizacao: boolean
  minimoAnexosPreAutorizacao: number
  nomeContratado: string | null
  createdAt: string
  updatedAt: string | null
  credencialElegibilityId: string | null
  tiposToken: CredencialTipoToken[]
  tipoPermissao: TipoPermissao
  conselho: string | null
  ufConselho: string | null
  numeroConselho: string | null
  nomeSolicitante: string | null
  especialidadeSolicitante: EspecialidadeSelect | null
  executantePadrao: ProfissionalResumo | null
  indicacaoClinicaTexto: string | null
  indicacaoClinicaMin: number
  indicacaoClinicaMax: number
  regimeAtendimento: string | null
  tipoAcidente: string | null
  tipoConsulta: string | null
  procedimentosPorGuia: number
}

const CAMPOS_CONDUTA = [
  'conselho',
  'ufConselho',
  'numeroConselho',
  'nomeSolicitante',
  'especialidadeSolicitante',
  'executantePadrao',
  'indicacaoClinicaTexto',
  'regimeAtendimento',
  'tipoAcidente',
] as const satisfies readonly (keyof Credencial)[]

const REGIME_ATENDIMENTO_PADRAO = 'E'
const TIPO_ACIDENTE_PADRAO = '9'

export const comCondutaPadrao = (credencial: Credencial): Credencial => {
  const temConduta = CAMPOS_CONDUTA.some((campo) => Boolean(credencial[campo]))
  if (!temConduta) return credencial

  return {
    ...credencial,
    regimeAtendimento: credencial.regimeAtendimento || REGIME_ATENDIMENTO_PADRAO,
    tipoAcidente: credencial.tipoAcidente || TIPO_ACIDENTE_PADRAO,
  }
}

export const STATUS_CREDENCIAL = {
  Todas: 'Todas',
  Ativas: 'Ativas',
  Inativas: 'Inativas',
} as const

export type StatusCredencial = (typeof STATUS_CREDENCIAL)[keyof typeof STATUS_CREDENCIAL]

export const situacaoCredencialBadges = [
  { value: STATUS_CREDENCIAL.Ativas, label: 'Ativas', tone: 'success' as const },
  { value: STATUS_CREDENCIAL.Inativas, label: 'Inativas', tone: 'neutral' as const },
]

export interface ListarCredenciaisFiltro {
  clienteId?: string | null
  operadoraId?: string | null
  tiposCredenciaisId?: string | null
  busca?: string | null
  situacao: StatusCredencial
  pageNumber: number
  pageSize: number
}

export interface ClienteResumo {
  id: string
  nome: string | null
  cpfCnpj: string | null
  razaoSocial: string | null
}

export interface PlanoCredencial {
  id: string
  descricao: string | null
  codigo: string | null
}

export interface ProcedimentoTabelaPropria {
  id: string
  descricao: string | null
  codigo: string | null
  codigoTuss: string | null
  codigoAutorizacao: string | null
  valor: number | null
  ativo: boolean
  codigosDesmembra: string | null
  desmembra: boolean
}
